export enum AffiliateFeatureEnum {
  OTPAuthOnly = 1,
  UseTelegraDashboard = 2,
}
